/* SmartPixel — interacciones propias (prefijo sp-) */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal + cifras animadas (un único observer) ---------- */
  function animateCount(el) {
    if (el.dataset.spDone) return;
    el.dataset.spDone = '1';
    var target = parseFloat(el.dataset.spCount) || 0;
    var decimals = (el.dataset.spCount.split('.')[1] || '').length;
    if (reduceMotion) { el.textContent = target.toLocaleString('en-US', { minimumFractionDigits: decimals }); return; }
    var start = null, dur = 1600;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initObserver(root) {
    var els = (root || document).querySelectorAll('.sp-reveal:not(.sp-visible), [data-sp-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sp-visible'); if (el.dataset.spCount) animateCount(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('sp-visible');
        if (el.dataset.spCount) animateCount(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-sp-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var k = parseFloat(el.dataset.spParallax) || 0;
        var rect = el.parentElement.getBoundingClientRect();
        if (rect.bottom < 0) return;
        el.style.transform = 'translate3d(0,' + (-rect.top * k).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Demo de pantalla LED ---------- */
  function initPixelDemo(root) {
    (root || document).querySelectorAll('[data-sp-demo]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var canvas = wrap.querySelector('canvas');
      var input = wrap.querySelector('.sp-demo__input');
      var swatches = wrap.querySelectorAll('.sp-demo__swatch');
      var ctx = canvas.getContext('2d');
      var cols = parseInt(wrap.dataset.cols, 10) || 64;
      var rows = Math.round(cols / 2);
      var speed = parseFloat(wrap.dataset.speed) || 1;
      var mode = 'rainbow', color = '#FFB347';
      var text = (input && input.value) || wrap.dataset.text || 'HELLO';
      var off = document.createElement('canvas');
      var offCtx = off.getContext('2d');
      var mask = null, maskW = 0, scroll = 0, hue = 0, visible = true;

      function buildMask() {
        var fontSize = Math.round(rows * 0.62);
        offCtx.font = '700 ' + fontSize + 'px Arial, sans-serif';
        maskW = Math.ceil(offCtx.measureText(text).width) + cols;
        off.width = maskW; off.height = rows;
        offCtx.font = '700 ' + fontSize + 'px Arial, sans-serif';
        offCtx.fillStyle = '#fff';
        offCtx.textBaseline = 'middle';
        offCtx.fillText(text, cols, rows / 2 + 1);
        mask = offCtx.getImageData(0, 0, maskW, rows).data;
        scroll = 0;
      }

      function resize() {
        var w = canvas.clientWidth || 600;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = w * dpr; canvas.height = (w / 2) * dpr;
      }

      function draw() {
        var cw = canvas.width, ch = canvas.height;
        var cell = cw / cols, r = cell * 0.36;
        ctx.clearRect(0, 0, cw, ch);
        var start = Math.floor(scroll);
        for (var y = 0; y < rows; y++) {
          for (var x = 0; x < cols; x++) {
            var mx = (start + x) % maskW;
            var on = mask[(y * maskW + mx) * 4 + 3] > 110;
            var cx = x * cell + cell / 2, cy = y * cell + cell / 2;
            if (on) {
              ctx.fillStyle = mode === 'rainbow' ? 'hsl(' + ((hue + x * 4 + y * 2) % 360) + ',95%,62%)' : color;
              ctx.shadowColor = ctx.fillStyle; ctx.shadowBlur = cell * 0.9;
            } else {
              ctx.fillStyle = 'rgba(255,255,255,0.06)'; ctx.shadowBlur = 0;
            }
            ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill();
          }
        }
        ctx.shadowBlur = 0;
      }

      function loop() {
        if (visible) {
          scroll = (scroll + 0.35 * speed) % maskW;
          hue = (hue + 1.2) % 360;
          draw();
        }
        requestAnimationFrame(loop);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(canvas);
      }
      if (input) {
        input.addEventListener('input', function () { text = input.value.trim() || ' '; buildMask(); });
      }
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          mode = sw.dataset.mode || 'solid';
          color = sw.dataset.color || color;
        });
      });
      window.addEventListener('resize', function () { resize(); draw(); });
      resize(); buildMask();
      if (reduceMotion) { scroll = cols; draw(); } else { loop(); }
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-sp-gallery]').forEach(function (gal) {
      if (gal.dataset.spReady) return;
      gal.dataset.spReady = '1';
      var slides = gal.querySelectorAll('.sp-gallery__main img');
      var thumbs = gal.querySelectorAll('.sp-gallery__thumb');
      var current = 0;
      function go(i) {
        if (!slides.length) return;
        current = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); });
      }
      gal.spGoToMedia = function (mediaId) {
        slides.forEach(function (s, k) { if (s.dataset.mediaId === String(mediaId)) go(k); });
      };
      var initial = 0;
      slides.forEach(function (s, k) { if (s.classList.contains('is-active')) initial = k; });
      go(initial);
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = gal.querySelector('.sp-gallery__nav--prev');
      var next = gal.querySelector('.sp-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var x0 = null;
      var main = gal.querySelector('.sp-gallery__main');
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    });
  }

  /* ---------- Selector de variantes + cantidad ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-sp-product]').forEach(function (wrap) {
      if (wrap.dataset.spReady) return;
      wrap.dataset.spReady = '1';
      var dataEl = wrap.querySelector('script[data-sp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = wrap.querySelector('input[name="id"]');
      var priceNow = wrap.querySelector('[data-sp-price]');
      var priceWas = wrap.querySelector('[data-sp-compare]');
      var save = wrap.querySelector('[data-sp-save]');
      var btn = wrap.querySelector('[data-sp-add]');
      var selectedLabel = wrap.querySelectorAll('[data-sp-selected]');
      var gallery = wrap.querySelector('[data-sp-gallery]');
      var stock = wrap.querySelector('[data-sp-stock]');
      var fmt = wrap.dataset.moneyFormat || '${{amount}}';

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var parts = v.split('.');
        var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
      }

      function update() {
        var chosen = [];
        wrap.querySelectorAll('.sp-options').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        var v = variants.find(function (vr) { return vr.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.textContent = onSale ? money(v.compare_at_price) : ''; priceWas.hidden = !onSale; }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = save.dataset.label.replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100)); }
        if (btn) { btn.disabled = !v.available; btn.querySelector('span').textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
        if (stock) stock.hidden = !v.available;
        selectedLabel.forEach(function (el, i) { el.textContent = chosen[i] || ''; });
        if (gallery && gallery.spGoToMedia && v.featured_media) gallery.spGoToMedia(v.featured_media.id);
        if (wrap.dataset.updateUrl === 'true' && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      wrap.querySelectorAll('.sp-options input').forEach(function (inp) { inp.addEventListener('change', update); });

      var qty = wrap.querySelector('.sp-qty input');
      wrap.querySelectorAll('.sp-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qty.value, 10) || 1) + (b.dataset.dir === 'up' ? 1 : -1);
          qty.value = Math.max(1, n);
        });
      });
    });
  }

  function initAll(root) {
    initObserver(root); initPixelDemo(root); initGallery(root); initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(); initParallax(); });
  /* Editor de Shopify: re-inicializar al cargar/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
